<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Notas de Crédito pendientes de subir a Fel</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div>
              <div class="form-inline justify-content-sm-end">
                <input
                  class="form-control text-center form-control-sm rounded bright"
                  placeholder="Serie"
                  v-model="search.abono_serie"
                  type="text"
                  style="width: 80px; text-transform: uppercase"
                  v-on:keyup.enter="filterData"
                />
                &nbsp;&nbsp;
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Nit cliente"
                  v-model="search.cliente"
                  type="text"
                  v-on:keyup.enter="filterData"
                  style="width: 100px; text-transform: uppercase"
                />
                &nbsp;&nbsp;
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="# Abono"
                  v-model="search.numero"
                  type="text"
                  style="width: 80px; text-transform: uppercase"
                  v-on:keyup.enter="filterData"
                />
                &nbsp;&nbsp;
                <input
                  type="date"
                  v-model="search.fecha"
                  style="width: 140px"
                  class="form-control form-control-sm rounded bright"
                />
                &nbsp;&nbsp;
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filtro_tienda"
                  @change="filterData"
                  style="width: 150px"
                >
                  <option value="">Tiendas</option>
                  <option
                    v-for="data in tiendas"
                    :value="data.codigo"
                    v-bind:key="data.id"
                  >
                    {{ data.nombre }}
                  </option>
                </select>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filtro_estado"
                  @change="filterData"
                  style="width: 108px"
                >
                  <option value>Estatus</option>
                  <option value="9">Anulado</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                  <option value="E">IMPRESA</option>
                </select>
                <div class="input-group-append">
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="filterData"
                    style="width: 60px"
                  >
                    <i class="fa fa-search"></i>
                    Buscar
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                    style="width: 30px"
                  >
                    <i class="fa fa-times"></i>
                    Limpiar Datos
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <!-------------------- Tabla de Resultados -------------------->

          <table class="table table-lightborder table-striped table-hover">
            <thead>
              <tr>
                <th>#</th>
                <th>Nit</th>
                <th>Cliente</th>
                <th>Fecha</th>
                <th>Monto</th>
                <th class="text-center">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="current in dataTabla.results"
                v-bind:key="current.id"
                @click="rowClick(current)"
              >
                <td>{{ current.numero }}</td>
                <td v-if="current.cliente">{{ current.cliente.nombre }}</td>
                <td v-if="current.cliente">{{ current.cliente.nit }}</td>
                <td v-if="current.cliente == null"></td>
                <td v-if="current.cliente == null"></td>
                <td>{{ current.fecha }}</td>
                <td>{{ current.total }}</td>
                <td class="text-center">
                  <div
                    data-title="Activo"
                    data-toggle="tooltip"
                    v-html="current.estado_str"
                  ></div>
                </td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
          <PaginationComponent
            :currentPage="currentPage"
            :data="dataTabla"
            @pagechanged="onPageChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import PaginationComponent from "@/components/utils/PaginationComponent";

export default {
  components: {
    PaginationComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      dataTabla: [],
      search: [],
      mostrarRefresh: false,
      currentPage: 1,
      filtro_estado: "",
      data: "",
      page: "",
      tiendas: "",
      filtro_tienda: "",
    };
  },
  mounted() {
    this.filterData();
    this.refreshTienda();
  },
  methods: {
    convertFormatDate(search) {
      search.fecha_creacion = moment(search.fecha).format("DD/MM/YYYY");
    },
    refreshTienda() {
      let self = this;
      DynamicService.fetch("cat", "tiendas", {
        quitar_paginacion: true,
      }).then((response) => {
        self.tiendas = response.data;
      });
    },
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "cxc-abonos-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "cxc-abonos-editar",
          params: { id: current.id },
        });
      }
    },
    onPageChange(page) {
      if (this.search.fecha) {
        this.convertFormatDate(this.search);
      }
      this.currentPage = page;
      this.refreshData({
        page: page,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
        abono_serie: this.search.abono_serie,
        cliente: this.search.cliente,
        numero: this.search.numero,
        tienda: this.filtro_tienda,
        fecha: this.search.fecha_creacion,
        pendiente_enviar_fel: true,
      });
    },
    filterData() {
      if (this.search.fecha) {
        this.convertFormatDate(this.search);
      }
      this.refreshData({
        page: this.$data.currentPage,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
        tienda: this.filtro_tienda,
        abono_serie: this.search.abono_serie,
        cliente: this.search.cliente,
        numero: this.search.numero,
        fecha: this.search.fecha_creacion,
        pendiente_enviar_fel: true,
      });
    },
    clearFilterData() {
      this.filtro_tienda = "";
      this.filtro_estado = "";
      this.searchtext = "";
      this.filterActiva = null;
      this.search = {
        abono_serie: "",
        cliente: "",
        numero: "",
        fecha: "",
      };
      this.refreshData({
        page: 1,
        pendiente_enviar_fel: true,
        "filter[search]": this.searchtext,
      });
    },
    refreshData(params) {
      let self = this;
      DynamicService.fetch("cxc", "abonos", params).then((res) => {
        self.dataTabla = res.data;
      });
    },
  },
};
</script>
